import React from "react";

import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Header.css";

const Navigate = () => {
  window.location.href = `https://projectscyp.weebly.com/`;
};

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Chaeyeon Park" />
      <h1 className="app__header-h1">
        Sustainability through Children's education
      </h1>
      <p className="p__opensans_lower_case" style={{ margin: "2rem 0" }}>
        The Myoja is a children’s storybook on the effects of light pollution.
        The story takes place in a quasi-mythical rural village off the Korean
        coast of South Gyeongsang, and follows the story of how a particular
        creature disappears following the introduction of a strange new light
        source.{" "}
      </p>
      <button type="button" className="custom__button" onClick={Navigate}>
        Learn More
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.myoja} alt="header_img" />
    </div>
  </div>
);

export default Header;
